var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplyLayout',[_c('ApplyForm',{on:{"form-submitted":_vm.submitData}}),(_vm.loading)?_c('PageLoading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }